// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".editRemoveButtonContainer___6ytrQ{display:flex;gap:16px}\n", "",{"version":3,"sources":["webpack://./src/components/TenantOverrideButton/TenantOverrideButton.css"],"names":[],"mappings":"AAAA,mCACI,YAAA,CACA,QAAA","sourcesContent":[".editRemoveButtonContainer {\n    display: flex;\n    gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editRemoveButtonContainer": "editRemoveButtonContainer___6ytrQ"
};
export default ___CSS_LOADER_EXPORT___;
